import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';


@Component({
  selector: 'app-project-item',
  templateUrl: './project-item.component.html',
  styleUrls: ['./project-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectItemComponent implements OnInit {

  private _ready = false;

  @HostBinding('class.hidden') hidden = false;
  @Output() onConfig = new EventEmitter<number>();
  @Output() onLaunch = new EventEmitter<number>();

  private _project: any = {};
  @Input()
  public set project(p: any) {
    this._project = p;
    if (!!p && !!p.workflow_id && !!p.workflow_stages) {
      this._workflowStages = p.workflow_stages;
      this._projectStage = p.stage;
    }
    this.hidden = this._project.__visibility === false;
    this.Refresh();
  }
  public get project(): any {
    return this._project;
  }
  constructor(private cdr: ChangeDetectorRef) { }

  public get projectName(): string {
    return (!!this._project.label) ? this._project.label : '';
  }

  public get created(): string {
    if (!this.project) return '';
    if (!this.project.created) return '';
    const dtime = new Date(Number(this.project.created) * 1000);
    return dtime.toDateString() + ' ' + dtime.toLocaleTimeString();
  }
  public get modified(): string {
    if (!this.project) return '';
    if (!this.project.modified) return '';
    const dtime = new Date(Number(this.project.modified) * 1000);
    return dtime.toDateString() + ' ' + dtime.toLocaleTimeString();
  }

  public get projectWorkflow(): string {
    return (!!this.project.workflow) ? this.project.workflow : '';
  }

  public get projectStageId(): string {
    return (!!this.project.stage) ? '' + this.project.stage : '';
  }

  private _workflowStages?: Array<any>;
  public get workflowStages(): Array<any> {
    if (!this.hasWorkflow) return [];
    return (!!this._workflowStages) ? this._workflowStages : [];
  }



  public get hasWorkflow(): boolean {
    return this.workflowName !== '';
  }

  public get workflowName(): string {
    if (!this._project) return '';
    return (!!this._project.workflow_name) ? this._project.workflow_name : '';
  }

  private _projectStage?: any;
  public set projectStage(stage: any) {
    this._projectStage = stage;
  }
  public get projectStage(): any {
    if (!this._projectStage) return -1;
    return this._projectStage;
  }

  public get stageName(): string {
    if (!!this._project && this._workflowStages && (Number(this.projectStageId) > -1)) {
      let match = '';
      this._workflowStages.every((stage: any, i: number) => {
        if (!!stage.id) {
          match = stage.name;
          return false;
        }
        return true;
      });
      return match;
    }
    return '';
  }
  ngOnInit(): void {
    this._ready = true;
  }
  Refresh() {
    this.cdr.detectChanges();
  }
  public EditConfig() {
    if(!this._project) return;
    this.onConfig.emit(this._project.project_id);
  }
  public Open() {
    if(!this._project) return;
    this.onLaunch.emit(this._project.project_id)
  }

}
